import React from 'react';
import axios from 'axios';
import { Form, Input, Alert, Radio, message } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import stickyError from 'components/stickyError';
import SaveButton from 'components/SaveButton';

class Accomodations extends React.Component {
	state = {
		submitting: false
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((err, values) => {
			if (err) {
				this.props.isSubmitted();
				return stickyError(err.message);
			}
			const matchingRemark = this.props.remarks && this.props.remarks.find(remark => remark.Code === 'SPACCOM');
			const data = Object.assign({}, values, (matchingRemark)?{id:matchingRemark.AssignId}:{});
			axios({
				method: (matchingRemark && matchingRemark.AssignId) ? 'put' : 'post',
				url: apiPath+'/remark/38',
				data: data,
				withCredentials: true
			}).then(result => {
				this.props.isSubmitted();
				this.props.refreshRemarks();
				message.success('Saved!');
			}).catch(error => {
				this.props.isSubmitted();
				this.props.handleAxiosSaveError(error);
			});
		});
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'health/special');
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'health/special');
			if (redirect) return redirect;
		}

		const matchingRemark = this.props.remarks && this.props.remarks.find(remark => remark.Code === 'SPACCOM');
		const remark = Object.assign({
			rmkNumericCheck1: null,
			Comments: ''
		}, matchingRemark);

		const { getFieldDecorator } = this.props.form;
		return (
			<Form className="withSpacing" onSubmit={this.handleSubmit}>
				<p>
					ISE seeks to provide a welcoming and inclusive shipboard environment for all participants regardless of sex, gender identity, race/ethnicity, disability status, veteran status, or religious identity.
					We also understand that some participants may need additional accommodations (in regards to cabin placement) in order to be successful throughout the voyage.
					These accommodations may include but are not limited to students who identify as transgender, students with physical disabilities or limited mobility, students needing religious accommodations for the academic schedule, or students needing additional mental health support.
				</p>
				<p>
					*Please note, information about special accommodations you may have already disclosed in the required medical form is confidential and therefore is not shared with anyone other than the health/medical team.
					Be advised, information disclosed in THIS form may be shared with relevant SAS staff and partners (including but not limited to select home office and on-ship staff/faculty and Field Program partners as relevant.)
					Due to the unique nature of the SAS program and constraints of the ship, not all accommodations and requests can be guaranteed and SAS cannot be responsible for ensuring such accommodations and requests.
					SAS will support participants in communicating, advocating and planning for their needs, but cannot guarantee complete compliance.
				</p>
				<p>
					<strong>This is not a confirmation of accommodation. Accommodating every unique restriction for every participant is not possible given the unique challenges of working with many different providers in many different countries around the world. </strong>
				</p>
				<Form.Item label="Do you identify with any of the special circumstances listed or do you need any other special accommodations?" className="inResco wrapLabel">
					{getFieldDecorator('checked', {
						initialValue: remark.rmkNumericCheck1
					})(
						<Radio.Group
							options={[{value: '1', label: 'Yes'}, {value: '0', label: 'No'}]}
							disabled={disabled}
							onChange={(e) => {
								if (e.target.value === '0') this.props.form.setFieldsValue({comments: ''});
							}} />
					)}
				</Form.Item>
				<Form.Item style={{display:(this.props.form.getFieldValue('checked') === '1') ? 'inherit' : 'none'}}
					label="Would you like to provide more information on this form regarding your needs, or would you like to speak to a Semester at Sea Representative?" className="inResco wrapLabel">
					{getFieldDecorator('comments', {
						initialValue: remark.Comments,
						rules: [{max: 200, message: 'Comments are too long (max 200 characters)'}]
					})(
						<Input type="textarea" disabled={disabled} />
					)}
				</Form.Item>
				<SaveButton
					disabled={!this.props.form.isFieldsTouched()}
					loading={this.state.submitting} />
			</Form>
		);
	}
}

export default withSpin(Form.create()(Accomodations));



// WEBPACK FOOTER //
// ./portal-components/Portal/Health/Accomodations.jsx